module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-BlackItalic.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-BlackItalic.woff2
// module id = 59
// module chunks = 8